export const joinArray = (array, seperator) => {
  return array.join(seperator);
}